export const FEATURE_FLAGS = {
  LIVE_AND_INVEST: true,
  READ_OUR_STORY: true,
  LEARN_MORE: true,
  VIEW_ALL_PROJECTS: false,
  CONTACT_US: true,
  CAREER: true,
  NEWS: true,
  // Enable/disable "All blog posts" section in LearnMoreNews page
  // Set to true to show, false to hide
  ALL_BLOG_POSTS: false,
  // Career & CareerDetail: true = Thai only (UI + API), false = use site language (can show English)
  CAREER_THAI_ONLY: true,
};

export function isFeatureEnabled(flagName) {
  return FEATURE_FLAGS[flagName] === true;
}

